import RestX from 'highered-utils/restx';
import i18n from '~/i18n';

class MessageService {
    static newMessage(title, message, duration = 5000) {
        RestX.getInterfaces().messageModule.addNewMessage({
            title: title,
            message: message,
            duration: duration,
        });
    }

    static error(title, error) {
        RestX.getInterfaces().messageModule.addNewMessage({
            title: title,
            message: error,
            state: 'ERROR',
            duration: 10000,
        });
    }

    static errorWithMapper(title, error, mapper, titleMapper) {
        if (!mapper) {
            return;
        }
        if (titleMapper) {
            title = titleMapper(error);
        }

        RestX.getInterfaces().messageModule.addNewMessage({
            title: title,
            message: mapper(error),
            state: 'ERROR',
            duration: 10000,
        });
    }

    // showFavoritedMessage shows a notification message when you favorite a job
    static showFavoritedMessage() {
        RestX.getInterfaces().messageModule.addNewMessage({
            title: i18n.t('components.smart.companyModule.favoritedTitle'),
            message: i18n.t('components.smart.companyModule.favoritedMessage'),
            state: 'INFO',
            duration: 5000,
            icon: 'heart',
        });
    }

    // showUnfavoritedMessage shows a notification message when you unfavorite a job
    static showUnfavoritedMessage() {
        RestX.getInterfaces().messageModule.addNewMessage({
            title: i18n.t('components.smart.companyModule.unfavoritedTitle'),
            message: i18n.t(
                'components.smart.companyModule.unfavoritedMessage'
            ),
            state: 'INFO',
            duration: 5000,
        });
    }
}

export default MessageService;
